import moment from "moment";
import React from "react";
import SituacaoExame from "./SituacaoExame";
import ImageSearchIcon from "@material-ui/icons/ImageSearch";
import SearchIcon from "@material-ui/icons/Search";
import PopperCustomMenu from "../../../components/Popper/PopperCustomMenu";

export const columns = ({ handleVisualizarImagem, handleBuscarResultado, loadingBuscarResultado }) => [
  {
    id: "dataSolicitacao",
    Header: "Data",
    field: "atendimentoDataHora",
    width: "140px",
    getValue: (value) =>
      moment(value?.atendimentoDataHora).format("DD/MM/YYYY HH:mm"),
  },
  {
    id: "exame",
    Header: "Exame",
    field: "exameNome",
    getValue: (value) => value?.exameNome || "-",
  },
  {
    id: "modalidade",
    Header: "Mod.",
    field: "modalidade",
    width: "50px",
    getValue: (value) => value?.modalidade || "-",
  },
  {
    id: "status",
    Header: "Status",
    field: "laudoGerado",
    width: "45px",
    getValue: (value) => {
      return (
        <div>
          <SituacaoExame laudoGerado={value?.laudoGerado} />
        </div>
      );
    },
  },
  {
    id: "acoes",
    Header: "Ações",
    width: "40px",
    getValue: (value) => {
      const isLoading = loadingBuscarResultado === value?.id;
      const menuItems = [
        {
          ativo: !!value?.pacienteAnexo?.id,
          label: "Visualizar Imagem",
          icon: <ImageSearchIcon style={{ fontSize: 18 }} />,
          onClick: () => handleVisualizarImagem(value),
        },
        {
          ativo: !value?.pacienteAnexo?.id && !isLoading,
          label: "Buscar Resultado",
          icon: <SearchIcon style={{ fontSize: 18 }} />,
          onClick: () => handleBuscarResultado(value),
        },
      ];

      return (
        <PopperCustomMenu
          menuOpcoes={menuItems}
          colorIcon={"#505050"}
          closePopperAfterClickOption
          colorButton={{
            background: "transparent",
          }}
        />
      );
    },
  },
];
